// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select-fields ul[data-v-1176ef63] {\n  -moz-column-count: 3;\n       column-count: 3;\n  -moz-column-gap: 20px;\n       column-gap: 20px;\n}\n.select-fields ul li[data-v-1176ef63]:not(:last-child) {\n  margin-bottom: 5px;\n}", ""]);
// Exports
module.exports = exports;
